import logo from '../assets/imgs/cerbranorte/logo.svg'
import logo_white from '../assets/imgs/cerbranorte/logo.svg'

export default {
    logo,
    logo_white,
    name: "Cerbranorte",
    title: "Cerbranorte Assembleias",
    appcode: 2,
    captchaSiteKey: "6LebO8IhAAAAAApCTVQlIKAmnnP2suTrTsWAuAUk",
    facebookAppId: "",
    googleAppId: "",
    googleTrackingId: "G-J2CRKSSP2R",
    showPA: false,
    showGroup: false,
    allowPublicMessages: true,
    allowPrivateMessages: true,
    accessCodeByEmail: false,
    enableGuestAccess: true,
    showMyLivestreamsByAgencyAndGroup: false,
    showBallotPaper: false
};
